// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhh_a big_bi"};